import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import Swal from 'sweetalert2';
import { IUser } from 'src/app/_interfaces/IUser.types';
import { AuthService } from 'src/app/_services/auth.service';
import { UserService } from 'src/app/_services/user.service';
import { RoutingService } from 'src/app/_services/routing.service';
import { ServiceManagment } from 'src/app/_services/service_managment';
import { AlertService } from 'src/app/_helpers/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { SendNotificationComponent } from '../send-notification/send-notification.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class NavbarComponent implements OnInit {
  user!: IUser;
  tempFeatured: any;
  constructor(
    private _authService: AuthService,
    private _userService: UserService,
    private alertService: AlertService,
    private serviceManagement: ServiceManagment,
    public routing: RoutingService,
    private dialogRef: MatDialog
  ) {
    this._userService.userObservable.subscribe((user: IUser) => {
      this.user = user;
    });
  }

  async ngOnInit() {
    await this.getPermission();
  }

  logout() {
    Swal.fire({
      title: 'Log Out',
      text: 'Sure you want to Log Out',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Log Out',
      confirmButtonColor: '#0b5455',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.value) {
        this._authService.logout({ deviceId: this._authService.deviceId });
      }
    });
  }

  goToChatListing() {
    this.routing.goToChatListing();
  }

  async getPermission() {
    await this.serviceManagement.getPermission().subscribe({
      next: (response: any) => {
        this.tempFeatured = response.data;
      },
      error: (errorResponse: any) => {
        this.alertService.show_alert(errorResponse, '', 'error');
      },
    });
  }

  openDialog() {
    this.dialogRef.open(SendNotificationComponent, {
      panelClass: 'SendNotification',
    });
  }
}
